// menu.js

let main_list = {
    "data":[
        {
            "headTitle1": "ড্যাশবোর্ড",
            "headTitle2": "নিয়মিত আপডেট দেখুন",
            "type": "headtitle"
        },
        {
            "path": "/dashboard",
            "title": "ড্যাশবোর্ড (Dashboard)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "path": "/admin/analytics",
            "title": "বিশ্লেষণ (Analytics)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "path": "/admin/remarks",
            "title": "মতামত (Remarks)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "headTitle1": "অভিযোগ",
            "headTitle2": "বিভিন্ন ধরণের অভিযোগ পরিচালনা করুন",
            "type": "headtitle"
        },
        {
            "path": "/admin/complaints/road",
            "title": "রাস্তা (Road)",
            "icon": "disc",
            "type": "link",
            "roles": ["road", "admin"]
        },
        {
            "path": "/admin/complaints/mosquito",
            "title": "মশা (Mosquito)",
            "icon": "disc",
            "type": "link",
            "roles": ["mosquito", "admin"]
        },
        {
            "path": "/admin/complaints/garbage",
            "title": "বর্জ্য (Waste)",
            "icon": "disc",
            "type": "link",
            "roles": ["garbage", "admin"]
        },
        {
            "path": "/admin/complaints/street_light",
            "title": "রাস্তার বাতি (Street Light)",
            "icon": "disc",
            "type": "link",
            "roles": ["street_light", "admin"]
        },
        {
            "path": "/admin/complaints/public_toilet",
            "title": "পাবলিক টয়লেট (Public Toilet)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "path": "/admin/complaints/drainage",
            "title": "নিষ্কাশন ব্যবস্থা (Drainage)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "path": "/admin/complaints/illegal_structure",
            "title": "অবৈধ কাঠামো (Illegal Structure)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "path": "/admin/complaints/waterlog",
            "title": "জলাবদ্ধতা (Waterlog)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "path": "/admin/complaints/air_pollution",
            "title": "বায়ু দূষণ (Air Pollution)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        },
        {
            "path": "/admin/complaints/noise_pollution",
            "title": "শব্দ দূষণ (Noise Pollution)",
            "icon": "disc",
            "type": "link",
            "roles": ["admin"]
        }
    ]
};

// get user role from localStorage (saved after login)
const userRole = localStorage.getItem("role") || "";


// build final menu based on user role
function buildMenu(userRole = "") {
    const final_list = { data: [] };
    let tempHeadtitle = null;
    let hasChildren = false;

    main_list.data.forEach(item => {
        if (item.type === "headtitle") {
            // start tracking new section
            tempHeadtitle = item;
            hasChildren = false;
        } else {
            // if item has no roles → skip
            if (!item.roles || item.roles.length === 0) return;

            // admin → sees everything
            if (userRole === "admin" || item.roles.includes(userRole)) {
                // push headtitle if not already pushed
                if (tempHeadtitle && !hasChildren) {
                    final_list.data.push(tempHeadtitle);
                    hasChildren = true;
                }
                final_list.data.push(item);
            }
        }
    });

    return final_list;
}

// final filtered menu
const final_list = buildMenu(userRole);

export default final_list;

